import { Model } from "@ofqual/portal-core/core/types";

export type Unit = {
  id: string,
  title: string,
  unitLevel: string,
  unitSubLevel: string,
  unitCredit: string,
  unitGLH: string,
  organisationName: string,
  organisationId: string,
  unitReferenceNumber: string,
  aounitReferenceNumber: string | null,
  unitSectorSubjectArea: string,
  unitEndDate: string,
  learningOutcomes: string,
  createdByUpn: string,
  createdByDisplayName: string,
  modifiedByUpn: string,
  modifiedByDisplayName: string,
  createdDate: string,
  modifiedDate: string,
  isEditable:boolean,
  unitLevelId: number,
};

export const fromApiModel = (model: Model): Unit => {
  return model as Unit;
};

export const toApiModel = (item: Unit): Model => {
  return {
    ...item,
  } as Model;
};

export const defaultValues = {
  title: "",
  unitLevel: "", 
  unitSubLevel: "",
  unitGLH: "",
  aounitReferenceNumber: null,
  unitEndDate: "",
  unitSectorSubjectArea: "",
  organisationId: "",
  learningOutcomes: "",
  unitCredit: ""
};